import React, { useState } from "react";
import { useSelector } from "react-redux";
import axios from '../../../axios'

function ConfirmPopup({ setConfirmPopUp, preread, setIsPopupOpen, setSubmitPopup, setShowPreRead }) {

    const userId = useSelector((state) => state.user?.currentUser?.id);


    const handleMarkComplete = async () => {
        try {
            let res = await axios.post(
                `/homework/preReadId/${preread.id}/studentPreRead/updateStatus/studentId/${userId}`,
                {
                    status: "completed",
                }
            );
            res && setAllQuestion({ ...allQuestion, sucessful: true });
        } catch (error) {
            console.log(error);
        }
    };
    return (
        <div className="ContainerSubmitedSucess">
            <div className="modal fade show d-block" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        {/* <div className="modal-header">
                        <img className="prereadLoader" src="/images/alert.svg" alt="icon" style={{ width: "60px", height: "60px", margin: "auto" }} />
                    </div> */}
                        <div className="modal-body text-center" style={{ fontSize: "20px", fontWeight: "500" }}>
                            {"Are you sure you want to submit pre-read!!"}
                        </div>
                        <hr style={{ margin: "15px 0px" }} />
                        <div className="flex gap-3 p-3 justify-center">
                            <div>
                                <button type="button" className="btn btn-danger" onClick={() => {
                                    setConfirmPopUp(false)
                                }}>Close</button>
                            </div>
                            <div>
                                <button type="button" className="btn submitBtnActivity" onClick={() => {
                                    if (typeof setShowPreRead === 'function') {
                                        setShowPreRead(false)
                                    } else {
                                        setIsPopupOpen(false)
                                    }
                                    handleMarkComplete()
                                    setConfirmPopUp(false)

                                    setSubmitPopup(true);
                                }}>Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ConfirmPopup;
